import type { ReactNode } from "react";

export default function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="border-line/40 bg-surface-alt flex flex-col items-center gap-3 border-2 border-dashed px-6 py-14 text-center">
      <h3 className="font-display text-heading text-ink font-bold">{title}</h3>
      {description && (
        <p className="text-body text-ink-muted max-w-md">{description}</p>
      )}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
